import filter from 'lodash/filter';
import head from 'lodash/head';
import find from 'lodash/find';
import pick from 'lodash/pick';
import mapKeys from 'lodash/mapKeys';

export class TransportationAlternativeService {
    constructor($resource, ApiService, DateService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
        this.dateService = DateService;
        this.shortDayName = {
            monday: "mon",
            tuesday: "tue",
            wednesday: "wed",
            thursday: "thu",
            friday: "fri",
            saturday: "sat",
            sunday: "sun"
        };
        this.specialRequirementsOptionsName = {
            wheelchair_access: "wheelchair access",
            door_to_door: "door to door",
            door_through_door: "door through door",
            curb_to_curb: "curb to curb"
        };
        this.transportationAlternativesListResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives');
        this.transportationAlternativesOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationAlternatives');
        this.transportationAlternativesSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives/sequence');
        this.transportationAlternativesPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives/publish');
        this.countyListResourceUrl = this.apiService.getResourceUrl('cms/service-area');
        this.callForHelpCountyListResourceUrl = this.apiService.getResourceUrl('cms/call-for-help/service-area');
        this.serviceTypeListResourceUrl = this.apiService.getResourceUrl('cms/service-type');
        this.paymentMethodsListResourceUrl = this.apiService.getResourceUrl('cms/payment-methods');

        // this.callForHelpListResourceUrl = this.apiService.getResourceUrl('cms/menus/CallForHelp');
        this.callForHelpDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/CallForHelp/content/:content_id');
        this.callForHelpOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/CallForHelp');
        this.callForHelpAddResourceUrl = this.apiService.getResourceUrl('cms/call-for-help');
        this.callForHelpEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/call-for-help/:content_id');

        this.ridesharingListResourceUrl = this.apiService.getResourceUrl('cms/menus/Ridesharing');
        this.ridesharingDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/Ridesharing/content/:content_id');
        this.ridesharingOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/Ridesharing');
        this.ridesharingAddResourceUrl = this.apiService.getResourceUrl('cms/ride-sharing');
        this.ridesharingEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/ride-sharing/:content_id');

        this.bicyclePedestrianListResourceUrl = this.apiService.getResourceUrl('cms/menus/BicycleAndPedestrian');
        this.bicyclePedestrianDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/BicycleAndPedestrian/content/:content_id');
        this.bicyclePedestrianOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/BicycleAndPedestrian');
        this.bicyclePedestrianAddResourceUrl = this.apiService.getResourceUrl('cms/bicycle-and-pedestrian');
        this.bicyclePedestrianEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/bicycle-and-pedestrian/:content_id');

        this.transportationProvidersDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationProviders/content/:content_id');
        this.transportationProvidersOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationProviders');
        this.transportationProvidersAddResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers');
        this.transportationProvidersEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers/:content_id');

        this.transportationProvidersSearchResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers/search');
        this.transportationProvidersSearchResource = this.$resource(this.transportationProvidersSearchResourceUrl);

        this.transportationAlternativesListResource = this.$resource(this.transportationAlternativesListResourceUrl);

        this.transportationAlternativesOverviewResource = this.$resource(this.transportationAlternativesOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationAlternativesSequenceResource = this.$resource(this.transportationAlternativesSequenceResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationAlternativesPublishPageResource = this.$resource(this.transportationAlternativesPublishPageResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.countyListResource = this.$resource(this.countyListResourceUrl);
        this.callForHelpCountyListResource = this.$resource(this.callForHelpCountyListResourceUrl);
        this.serviceTypeListResource = this.$resource(this.serviceTypeListResourceUrl);
        this.paymentMethodsListResource = this.$resource(this.paymentMethodsListResourceUrl);

        // this.callForHelpListResource = this.$resource(this.callForHelpListResourceUrl);
        this.callForHelpDetailByIdResource = this.$resource(this.callForHelpDetailByIdResourceUrl);
        this.callForHelpOverviewResource = this.$resource(this.callForHelpOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.callForHelpAddResource = this.$resource(this.callForHelpAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.callForHelpEditDeleteResource = this.$resource(this.callForHelpEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.ridesharingListResource = this.$resource(this.ridesharingListResourceUrl);
        this.ridesharingDetailByIdResource = this.$resource(this.ridesharingDetailByIdResourceUrl);
        this.ridesharingOverviewResource = this.$resource(this.ridesharingOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.ridesharingAddResource = this.$resource(this.ridesharingAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.ridesharingEditDeleteResource = this.$resource(this.ridesharingEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.bicyclePedestrianListResource = this.$resource(this.bicyclePedestrianListResourceUrl);
        this.bicyclePedestrianDetailByIdResource = this.$resource(this.bicyclePedestrianDetailByIdResourceUrl);
        this.bicyclePedestrianOverviewResource = this.$resource(this.bicyclePedestrianOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.bicyclePedestrianAddResource = this.$resource(this.bicyclePedestrianAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.bicyclePedestrianEditDeleteResource = this.$resource(this.bicyclePedestrianEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.transportationProvidersListResource = this.$resource(this.transportationProvidersListResourceUrl);
        this.transportationProvidersDetailByIdResource = this.$resource(this.transportationProvidersDetailByIdResourceUrl);
        this.transportationProvidersOverviewResource = this.$resource(this.transportationProvidersOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationProvidersAddResource = this.$resource(this.transportationProvidersAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.transportationProvidersEditDeleteResource = this.$resource(this.transportationProvidersEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });
    }

    _getOverviewDetails(details) {
        return {
            title: details.title,
            description: details.description,
            overview: details.overview,
            image: details.image
        }
    }

    _setOverviewObject(details) {
        return {
            title: details.title,
            description: details.description,
            image: details.image
        }
    }

    _getContentDetails(content) {
        return content.map(({ title, description, name, slug }) => ({ title, description, name, slug }));
    }

    _getHoursOfOperationDetails(value) {
        return {
            startTime: value.start_time ? this.dateService.parseDateFromServerDate(value.start_time) : "",
            endTime: value.end_time ? this.dateService.parseDateFromServerDate(value.end_time) : "",
            isAllDay: value.is_all_day
        }
    }

    _setHoursOfOperationDetails(value) {
        return {
            start_time: this._resetDateWithTime(value.startTime),
            end_time: this._resetDateWithTime(value.endTime),
            is_all_day: value.isAllDay
        }
    }

    _resetDateWithTime(date) {
        const time = date;
        return new Date(this.dateService.resetDateTimeWithOtherTime(date, time));
    }

    _getPhoneDetailsObject(values) {
        return values.map(({ extn, number }) => ({ extn, number }));
    }

    _setPhoneDetailsObject(values) {
        return values.map(({ extn, number }) => ({ extn, number }));
    }

    _getProviderPhoneDetailsObject(values) {
        return values.map(({ extn, number, name }) => ({ extn, number, name }));
    }

    _setProviderPhoneDetailsObject(values) {
        return values.map(({ extn, number, name }) => ({ extn, number, name }));
    }

    _getServiceAreaObject(values) {
        return values.map(value => ({
            id: value.service_area_id,
            name: `${value.name} (${value.state_code}) (${value.service_area_type})`,
            status: -1
        }));
    }

    _setServiceAreaObject(values) {
        return values.map(value => ({
            service_area_id: value.id,
            name: value.name,
            status: value.status
        }));
    }

    _getServiceTypeListObject(values) {
        return values.map(value => ({
            id: value.service_type_id,
            name: value.name
        }));
    }

    _getServiceTypeObject(values) {
        return values.map(value => ({
            id: value.service_type_id,
            name: value.service_type
        }));
    }

    _getPaymentMethodObject(values) {
        return values.map(value => ({
            id: value.payment_method_id,
            name: value.payment_method,
            status: -1
        }));
    }

    _setPaymentMethodObject(values) {
        return values.map(value => ({
            payment_method_id: value.id,
            payment_method: value.name,
            status: value.status
        }));
    }

    _getDaysOfOperation(values) {
        let arr = [];
        mapKeys(this.shortDayName, (value, key) => {
            let obj = {};
            obj.name = key;
            obj.isSelected = pick(values, [key])[key];
            obj.displayName = value
            arr.push(obj);
        });
        return arr;
    }

    _getSubContentDetails(values) {
        let details = filter(values, ['name', 'CallForHelp']);
        return _getListDetails.call(this, head(details).values);

        function _getListDetails(data) {
            return data.map(value => this._getTemplate1ListObject(value));
        }
    }

    //get content sequence object for display
    _getContentSequence({ content: { values } }) {
        return values.map(content => ({
            id: content.menu_id,
            sortOrder: content.sort_order,
            title: content.title
        }));
    }

    //set content sequence object for update
    _setContentSequence(value) {
        return value.map(content => ({
            menu_id: content.id,
            sort_order: content.sortOrder
        }));
    }

    //get publish status object for display
    _getPublishPageListObject(values) {
        return values.map(value => ({
            id: value.menu_id,
            isActive: value.is_active,
            title: value.title
        }));
    }

    //set publish status object for update
    _setPublishPageListObject(values) {
        return values.map(value => ({
            menu_id: value.id,
            is_active: value.isActive
        }));
    }

    _getTemplate1ListObject(value) {
        return {
            id: value.content_id,
            serviceArea: this._getServiceAreaObject(value.service_area),
            email: value.email,
            image: value.image,
            name: value.name,
            phone: this._setPhoneDetailsObject(value.phone),
            url: value.url,
            daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
            hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
            slug: value.slug || null
        }
    }

    _getTemplate1DetailObject(value) {
        return {
            basicInfo: {
                id: value.content_id,
                serviceArea: this._getServiceAreaObject(value.service_area),
                email: value.email,
                image: value.image,
                name: value.name,
                phone: this._setPhoneDetailsObject(value.phone),
                url: value.url
            },
            operationInfo: {
                daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation)
            }
        }
    }

    _getDaysOfOperationObject(values) {
        let selectedItems = {};
        values.map((value, index) => {
            selectedItems[value.name] = value.isSelected;
            return value;
        });
        return selectedItems;
    }

    _setTemplate1DetailObject(value) {
        return {
            service_area: this._setServiceAreaObject(value.basicInfo.serviceArea || value.serviceInfo.serviceArea),
            days_of_operation: this._getDaysOfOperationObject(value.operationInfo.daysOfOperation),
            email: value.basicInfo.email,
            hours_of_operation: this._setHoursOfOperationDetails(value.operationInfo.hoursOfOperation),
            image: value.basicInfo.image || '',
            name: value.basicInfo.name,
            phone: this._setPhoneDetailsObject(value.basicInfo.phone),
            url: value.basicInfo.url,
            status: value.status
        }
    }

    _getRideSharingDetails(values) {
        let details = filter(values, ['name', 'Ridesharing']);
        return _getListDetails.call(this, head(details).values);

        function _getListDetails(data) {
            return data.map(value => this._getTemplate1ListObject(value));
        }
    }

    _getTemplate2DetailObject(value) {
        return {
            id: value.content_id,
            serviceArea: this._getServiceAreaObject(value.service_area),
            image: value.image,
            name: value.name,
            url: value.url,
            description: value.description,
            slug: value.slug
        }
    }

    _setTemplate2DetailObject(value) {
        return {
            service_area: this._setServiceAreaObject(value.serviceArea),
            image: value.image,
            name: value.name,
            url: value.url,
            description: value.description
        }
    }

    _getBicyclePedestrianDetails(values) {
        let details = filter(values, ['name', 'BicycleAndPedestrian']);
        return _getListDetails.call(this, head(details).values);

        function _getListDetails(data) {
            return data.map(value => this._getTemplate2DetailObject(value));
        }
    }

    _getTransportationProvidersListObject(value) {
        return {
            id: value.content_id,
            serviceArea: this._getServiceAreaObject(value.service_area),
            email: value.email,
            image: value.image,
            name: value.name,
            phone: this._getProviderPhoneDetailsObject(value.phone_number),
            url: value.url,
            daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
            hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
            fees: value.fees,
            notes: value.notes,
            serviceType: this._getServiceTypeObject(value.service_type),
            methodOfPayment: this._getPaymentMethodObject(value.payment_methods),
            slug: value.slug || null
        }
    }

    _setTransportationProvidersListObject(value) {
        return {
            isCheckedDestinationForServiceArea: value.serviceInfo.isCheckedDestinationForServiceArea || false,
            service_area: this._setServiceAreaObject(value.serviceInfo.serviceArea),
            email: value.basicInfo.email,
            image: value.basicInfo.image,
            name: value.basicInfo.name.trim(),
            phone_number: this._setProviderPhoneDetailsObject(value.basicInfo.phone),
            url: value.basicInfo.url,
            days_of_operation: this._getDaysOfOperationObject(value.operationInfo.daysOfOperation),
            hours_of_operation: this._setHoursOfOperationDetails(value.operationInfo.hoursOfOperation),
            fees: value.otherInfo.fees,
            notes: value.otherInfo.notes,
            service_type: this._setServiceTypeObject(value.serviceInfo.serviceType),
            payment_methods: this._setPaymentMethodObject(value.otherInfo.methodOfPayment),
            special_requirements: this._getCheckboxOptionsObject(value.serviceInfo.specialRequirements),
            medicaid_support: value.serviceInfo.medicaidSupport,
            veteran_support: value.serviceInfo.veteranSupport,
            status: value.status,
            costing: value.serviceInfo.costing
        }
    }

    _getTransportationProvidersDetailObject(value) {
        return {
            basicInfo: {
                id: value.content_id,
                email: value.email,
                image: value.image,
                name: value.name,
                phone: this._setProviderPhoneDetailsObject(value.phone_number),
                url: value.url
            },
            serviceInfo: {
                serviceType: this._getServiceTypeObject(value.service_type),
                serviceArea: this._getServiceAreaObject(value.service_area),
                specialRequirements: this._getCheckboxOptions(value.special_requirements, this.specialRequirementsOptionsName),
                medicaidSupport: value.medicaid_support,
                veteranSupport: value.veteran_support,
                costing: value.costing,
                isCheckedDestinationForServiceArea: value.isCheckedDestinationForServiceArea
            },
            operationInfo: {
                daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation)
            },
            otherInfo: {
                fees: value.fees,
                notes: value.notes,
                methodOfPayment: this._getPaymentMethodObject(value.payment_methods)
            }
        }
    }

    _getCheckboxOptions(values, optionNames) {
        let arr = [];
        mapKeys(optionNames, (value, key) => {
            let obj = {};
            obj.id = key;
            obj.isSelected = pick(values, [key])[key];
            obj.title = value
            arr.push(obj);
        });
        return arr;
    }

    _getCheckboxOptionsObject(values) {
        let selectedItems = {};
        values.map((value, index) => {
            selectedItems[value.id] = value.isSelected || false;
            return value;
        });
        return selectedItems;
    }

    _getServiceTypeObject(values) {
        return values.map(value => ({
            id: value.service_type_id,
            name: value.service_type,
            status: -1
        })
        );
    }

    _setServiceTypeObject(values) {
        return values.map(value => ({
            service_type_id: value.id,
            service_type: value.name,
            status: value.status
        }));
    }

    _getTransportationProvidersDetails(values) {
        let details = filter(values, ['name', 'TransportationProviders']);
        return _getListDetails.call(this, head(details).values);

        function _getListDetails(data) {
            return data.map(value => this._getTransportationProvidersListObject(value));
        }
    }

    _getMenuOverviewDetails(details) {
        return {
            id: details.content_id,
            displayName: details.display_name,
            title: details.title,
            description: details.description,
            image: details.image,
            name: details.name,
            overview: details.overview
        }
    }

    _getMenuContentDetails(value) {
        return {
            id: value.content_id,
            description: value.description,
            images: this._getContentImagesObject(value.images) || [],
            videos: value.videos || []
        }
    }

    _getContentImagesObject(values) {
        return values ? values.map(({ uuid }) => ({ uuid, status: -1 })) : [];
    }

    _setMenuContentDetails(value) {
        return {
            description: value.description,
            images: value.images || [],
            videos: value.videos || []
        }
    }

    /**
	 * function to get county list
	 * @return {object} [information related to county list]
	 */
    getCountyList() {
        const promise = this.countyListResource.get().$promise;

        return promise.then(details => this._getServiceAreaObject(details.data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getCallForHelpCountyList() {
        const promise = this.callForHelpCountyListResource.get().$promise;

        return promise
            .then(details => this._getServiceAreaObject(details.data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to get service type list
	 * @return {object} [information related to service type list]
	 */
    getServiceTypeList() {
        const promise = this.serviceTypeListResource.get().$promise;

        return promise.then(details => this._getServiceTypeListObject(details.data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to get payment methods list
	 * @return {object} [information related to payment methods list]
	 */
    getPaymentMethodsList() {
        const promise = this.paymentMethodsListResource.get().$promise;

        return promise.then(details => this._getPaymentMethodObject(details.data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to get transportation alternatives overview
	 * @return {object} [information related to transportation alternatives overview]
	 */

    getTransportationAlternativesOverview(details) {
        return this._getOverviewDetails(details.data);
    }

    /**
	 * function to get transportation alternatives list
	 * @return {object} [information related to transportation alternatives list]
	 */
    getTransportationAlternativesDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getContentDetails(details.data.children)
        };
    }

    /**
	 * function to edit transportation alternatives overview
	 * @return {object} [information related to transportation alternatives overview for edit]
	 */
    updateTransportationAlternativesOverview(details) {
        const promise = this.transportationAlternativesOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    //get content sequence service
    getTransportationAlternativesEditSequence(details) {
        return this._getContentSequence(details.data)
    }

    //update content sequence service
    setTransportationAlternativesEditSequence(sequenceObj) {
        const promise = this.transportationAlternativesSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

        return promise.then(response => response);
    }

    //get publish status list
    getTransportationAlternativesPublishPageList() {
        const promise = this.transportationAlternativesPublishPageResource.get().$promise;

        return promise.then(details => this._getPublishPageListObject(details.data));
    }

    //update publish status list
    setTransportationAlternativesPublishPageList(list) {
        const promise = this.transportationAlternativesPublishPageResource.update(this._setPublishPageListObject(list)).$promise;

        return promise.then(response => response);
    }

    /**
	 * function to get call for help list
	 * @return {object} [information related to call for help list]
	 */
    getFilterCallForHelpDetails({ limit = 10, page_id = 1 }, url) {
        this.callForHelpListResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
        this.callForHelpListResource = this.$resource(this.callForHelpListResourceUrl);

        const promise = this.callForHelpListResource.get({
            limit: limit,
            page_id: page_id
        }).$promise;

        return promise.then(details => ({
            list: this._getSubContentDetails(details.data.content),
            count: details.data.count
        }))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getCallForHelpDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getSubContentDetails(details.data.content),
            count: details.data.count
        };
    }

    /**
	 * function to get call for help detail by id
	 * @return {object} [information related to call for help detail by id]
	 */
    // getCallForHelpDetailsById(id) {
    //     const promise = this.callForHelpDetailByIdResource.get({
    //         content_id: id
    //     }).$promise;

    //     return promise.then(details => this._getTemplate1DetailObject(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getCallForHelpDetailsById(details) {
        return this._getTemplate1DetailObject(details.data)
    }

    /**
	 * function to get call for help overview
	 * @return {object} [information related to call for help overview]
	 */
    // getCallForHelpOverview() {
    //     const promise = this.callForHelpOverviewResource.get().$promise;

    //     return promise.then(details => this._getOverviewDetails(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getCallForHelpOverview(details) {
        return this._getOverviewDetails(details.data);
    }

    /**
	 * function to edit call for help overview
	 * @return {object} [information related to call for help overview for edit]
	 */
    updateCallForHelpOverview(details) {
        const promise = this.callForHelpOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to add call for help data
	 * @return {object} [information related to call for help data for add]
	 */
    // addCallForHelpDetail(details) {
    //     const promise = this.callForHelpAddResource.save(this._setTemplate1DetailObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to edit call for help data
	 * @return {object} [information related to call for help data for edit]
	 */
    updateCallForHelpDetail(details, id) {
        const promise = this.callForHelpEditDeleteResource.update({
            content_id: id
        }, this._setTemplate1DetailObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to delete call for help data
	 * @return {object} [information related to call for help data for delete]
	 */
    deleteCallForHelpData(id) {
        const promise = this.callForHelpEditDeleteResource.delete({ content_id: id }).$promise;

        return promise.then(details => details.data)
            .catch((err) => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    /**
	 * function to get ridesharing list
	 * @return {object} [information related to ridesharing list]
	 */
    getRidesharingDetailsByFilter({ limit = 10, page_id = 1 }, url) {
        this.ridesharingListResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
        this.ridesharingListResource = this.$resource(this.ridesharingListResourceUrl);

        const promise = this.ridesharingListResource.get({
            limit: limit,
            page_id: page_id
        }).$promise;

        return promise.then(details => ({
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getRideSharingDetails(details.data.content),
            count: details.data.count
        }))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getRidesharingDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getRideSharingDetails(details.data.content),
            count: details.data.count
        }
    }

    /**
	 * function to get ridesharing detail by id
	 * @return {object} [information related to ridesharing detail by id]
	 */
    // getRidesharingDetailsById(id) {
    //     const promise = this.ridesharingDetailByIdResource.get({
    //         content_id: id
    //     }).$promise;

    //     return promise.then(details => this._getTemplate1DetailObject(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getRidesharingDetailsById(details) {
        return this._getTemplate1DetailObject(details.data);
    }

    /**
	 * function to get ridesharing overview
	 * @return {object} [information related to ridesharing overview]
	 */
    // getRidesharingOverview() {
    //     const promise = this.ridesharingOverviewResource.get().$promise;

    //     return promise.then(details => this._getOverviewDetails(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getRidesharingOverview(details) {
        return this._getOverviewDetails(details.data);
    }

    /**
	 * function to edit ridesharing overview
	 * @return {object} [information related to ridesharing overview for edit]
	 */
    updateRidesharingOverview(details) {
        const promise = this.ridesharingOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to add ridesharing data
	 * @return {object} [information related to ridesharing data for add]
	 */
    // addRidesharingDetail(details) {
    //     const promise = this.ridesharingAddResource.save(this._setTemplate1DetailObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to edit ridesharing data
	 * @return {object} [information related to ridesharing data for edit]
	 */
    // updateRidesharingDetail(details, id) {
    //     const promise = this.ridesharingEditDeleteResource.update({
    //         content_id: id
    //     }, this._setTemplate1DetailObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to delete ridesharing data
	 * @return {object} [information related to ridesharing data for delete]
	 */
    deleteRidesharingData(id) {
        const promise = this.ridesharingEditDeleteResource.delete({ content_id: id }).$promise;

        return promise.then(details => details.data)
            .catch((err) => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    /**
	 * function to get bicycle pedestrian list
	 * @return {object} [information related to bicycle pedestrian list]
	 */
    getFilterBicyclePedestrianDetails({ limit = 10, page_id = 1 }, url) {
        this.bicyclePedestrianListResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
        this.bicyclePedestrianListResource = this.$resource(this.bicyclePedestrianListResourceUrl);

        const promise = this.bicyclePedestrianListResource.get({
            limit: limit,
            page_id: page_id
        }).$promise;

        return promise.then(details => ({
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getBicyclePedestrianDetails(details.data.content),
            count: details.data.count
        }))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getBicyclePedestrianDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getBicyclePedestrianDetails(details.data.content),
            count: details.data.count
        }
    }

    /**
	 * function to get bicycle pedestrian detail by id
	 * @return {object} [information related to bicycle pedestrian detail by id]
	 */

    getBicyclePedestrianDetailsById(details) {
        return this._getTemplate2DetailObject(details.data)
    }

    /**
	 * function to get bicycle pedetrian overview
	 * @return {object} [information related to bicycle pedetrian overview]
	 */
    getBicyclePedestrianOverview() {
        const promise = this.bicyclePedestrianOverviewResource.get().$promise;

        return promise.then(details => this._getOverviewDetails(details.data))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to edit bicycle pedestrian overview
	 * @return {object} [information related to bicycle pedestrian overview for edit]
	 */
    updateBicyclePedestrianOverview(details) {
        const promise = this.bicyclePedestrianOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to add bicycle pedestrian data
	 * @return {object} [information related to bicycle pedestrian data for add]
	 */
    // addBicyclePedestrianDetail(details) {
    //     const promise = this.bicyclePedestrianAddResource.save(this._setTemplate2DetailObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to edit bicycle pedestrian data
	 * @return {object} [information related to bicycle pedestrian data for edit]
	 */
    // updateBicyclePedestrianDetail(details, id) {
    //     const promise = this.bicyclePedestrianEditDeleteResource.update({
    //         content_id: id
    //     }, this._setTemplate2DetailObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to delete bicycle pedestrian data
	 * @return {object} [information related to bicycle pedestrian data for delete]
	 */
    deleteBicyclePedestrianData(id) {
        const promise = this.bicyclePedestrianEditDeleteResource.delete({ content_id: id }).$promise;

        return promise.then(details => details.data)
            .catch((err) => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    /**
	 * function to get transportation providers list
	 * @return {object} [information related to transportation providers list]
	 */
    getTransportationProviderDetailsByFilter({ limit = 10, page_id = 1 }, url) {
        this.transportationProvidersListResourceUrl = this.apiService.getResourceUrl(`cms/menus/${url}`);
        this.transportationProvidersListResource = this.$resource(this.transportationProvidersListResourceUrl);

        const promise = this.transportationProvidersListResource.get({
            limit: limit,
            page_id: page_id
        }).$promise;

        return promise.then(details => ({
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getTransportationProvidersDetails(details.data.content),
            count: details.data.count
        }))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    getTransportationProvidersDetails(details) {
        return {
            overview: this._getOverviewDetails(details.data.menuOverviewDetails),
            list: this._getTransportationProvidersDetails(details.data.content),
            count: details.data.count
        };
    }

    getTransportationProvidersByName(searchKey) {
        const promise = this.transportationProvidersSearchResource.get({
            search_key: searchKey
        }).$promise;

        return promise
            .then(transportationProviderDetails => transportationProviderDetails.data.map(value => this._getTransportationProvidersListObject(value)))
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to get transportation providers detail by id
	 * @return {object} [information related to transportation providers detail by id]
	 */
    // getTransportationProvidersDetailsByIdEdit(id) {
    //     const promise = this.transportationProvidersDetailByIdResource.get({
    //         content_id: id
    //     }).$promise;

    //     return promise.then(details => this._getTransportationProvidersDetailObject(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getTransportationProvidersDetailsByIdEdit(details) {
        return this._getTransportationProvidersDetailObject(details.data)
    }

    // getTransportationProvidersDetailsById(id) {
    //     const promise = this.transportationProvidersDetailByIdResource.get({
    //         content_id: id
    //     }).$promise;

    //     return promise.then(details => this._getTransportationProvidersListObject(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getTransportationProvidersDetailsById(details) {
        return this._getTransportationProvidersListObject(details.data);
    }

    /**
	 * function to get transportation providers overview
	 * @return {object} [information related to transportation providers overview]
	 */
    // getTransportationProvidersOverview() {
    //     const promise = this.transportationProvidersOverviewResource.get().$promise;

    //     return promise.then(details => this._getOverviewDetails(details.data))
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    getTransportationProvidersOverview(details) {
        return this._getOverviewDetails(details.data)
    }

    /**
	 * function to edit transportation providers overview
	 * @return {object} [information related to transportation providers overview for edit]
	 */
    updateTransportationProvidersOverview(details) {
        const promise = this.transportationProvidersOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    /**
	 * function to add transportation providers data
	 * @return {object} [information related to transportation providers data for add]
	 */
    // addTransportationProvidersDetail(details) {
    //     const promise = this.transportationProvidersAddResource.save(this._setTransportationProvidersListObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to edit transportation providers data
	 * @return {object} [information related to transportation providers data for edit]
	 */
    // updateTransportationProvidersDetail(details, id) {
    //     const promise = this.transportationProvidersEditDeleteResource.update({
    //         content_id: id
    //     }, this._setTransportationProvidersListObject(details)).$promise;

    //     return promise.then(details => details.data)
    //         .catch((error) => {
    //             throw this.apiService.getErrorMessage(error);
    //         });
    // }

    /**
	 * function to delete transportation providers data
	 * @return {object} [information related to transportation providers data for delete]
	 */
    deleteTransportationProvidersData(id) {
        const promise = this.transportationProvidersEditDeleteResource.delete({ content_id: id }).$promise;

        return promise.then(details => details.data)
            .catch((err) => {
                throw this.apiService.getErrorMessage(err);
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/transportation-alternative.service.js